const OurServiceItem = (props) => {
  return (
    <div className="col-md-6 col-xl-3 col-12">
        <div className="revamp-service-item">
            <div className="icon">
                {props.iconClass ? <i className={props.iconClass}></i> : <img src={props.imgUrl} alt="service" />}
            </div>
            <h4>{props.caption}</h4>
            <p>{props.description}</p>
            <div className="btn-wrap">{props.button}</div>
        </div>
    </div>
  );
};

export default OurServiceItem;